<template>
  <div class="navi-user-auth-links">
    <a
      class="navi-user-auth-link-item login"
      :href="props.loginLink"
    >
      {{ props.loginLabel }}
    </a>
    <a
      class="navi-user-auth-link-item register"
      :href="props.registerLink"
    >
      {{ props.registerLabel }}
    </a>
  </div>
</template>

<script setup>
const props = defineProps({
  loginLabel: {
    type: String,
    required: true,
  },
  loginLink: {
    type: String,
    required: true,
  },
  registerLabel: {
    type: String,
    required: true,
  },
  registerLink: {
    type: String,
    required: true,
  },
})
</script>

<style scoped lang="scss">
.navi-user-auth-links {
  display: flex;
  align-items: center;
  height: 100%;
  line-height: normal;
  white-space: pre;

  .navi-user-auth-link-item {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    color: #636363;
    border-radius: 3px;
    outline: none;
    cursor: pointer;
    padding: 9px 12px;

    &.login {
      margin-right: 6px;

      &:hover {
        background-color: #939393;
        color: #fff;
      }
    }

    &.register {
      background-color: #0386f4;
      color: #fff;

      &:hover {
        background-color: #0862BB;
      }
    }
  }
}
</style>
